import { getJson } from './client';
import type { HistoryResponse } from './types';

/** Default 24h history fetcher (backwards-compat alias). */
export const fetchHistory24h = () => getJson<HistoryResponse>('/api/history/24h');

/**
 * Adaptive history fetcher. Pulls up to `hours` of past data so the dashboard's
 * adaptive-horizon mode can fill empty right-edge with extra history when the
 * forecast horizon is short. Pi clamps to [1, 48] server-side.
 */
export const fetchHistory = (hours: number) =>
  getJson<HistoryResponse>(`/api/history/24h?hours=${Math.max(1, Math.min(48, Math.round(hours)))}`);
